<template lang="pug">
.c-text-editor(:class="$style.editor")
  ckeditor(:value="value"
    :editor="editor"
    :config="config"
    @input="$emit('update:value', $event)")
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "TextEditor",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      config: {
        toolbar: [
          "heading",
          "bold",
          "italic",
          "link",
          "bulletedlist",
          "numberedlist",
          "blockquote",
          "undo",
          "redo"
        ]
      }
    };
  }
};
</script>

<style module lang="styl">
.editor
  :global(.ck-editor__editable)
    height 60vh
    overflow-y scroll
</style>
